import type { MailContentProps, MailMetadata } from "../../lib/types";
import { calculateDateWithDateRelative } from "../../lib/utils";
import { MailSignature } from "../mail/mail-signature";

function CongesAVenir({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>Bonjour ,</p>
      <p>
        A titre d'information voici un récapitulatif des congés à venir qui ont
        été validés par votre prédécesseur :
      </p>
      <ul className="list-disc pl-12">
        <li>
          {variablesData.secretaire_prenom} {variablesData.secretaire_nom} :{" "}
          {calculateDateWithDateRelative(
            Number(variablesData.secretaire_date_debut_conges) || 0,
          )}{" "}
          au{" "}
          {calculateDateWithDateRelative(
            Number(variablesData.secretaire_date_fin_conges) || 0,
          )}
        </li>
        <li>
          {variablesData.collaborateur_1_prenom}{" "}
          {variablesData.collaborateur_1_nom} :{" "}
          {calculateDateWithDateRelative(
            Number(variablesData.collaborateur_1_date_debut_conges) || 0,
          )}{" "}
          au{" "}
          {calculateDateWithDateRelative(
            Number(variablesData.collaborateur_1_date_fin_conges) || 0,
          )}
        </li>
        <li>
          {variablesData.responsable_commercial_prenom}{" "}
          {variablesData.responsable_commercial_nom} :{" "}
          {calculateDateWithDateRelative(
            Number(variablesData.responsable_commercial_date_debut_conges) || 0,
          )}{" "}
          au{" "}
          {calculateDateWithDateRelative(
            Number(variablesData.responsable_commercial_date_fin_conges) || 0,
          )}
        </li>
      </ul>
      <MailSignature
        emetteurLogo={CongesAVenir.metadata.emetteurLogo}
        emetteur={CongesAVenir.metadata.emetteur}
        emetteurPoste={CongesAVenir.metadata.emetteurPoste}
        emetteurEntreprise={CongesAVenir.metadata.emetteurEntreprise}
      />
    </div>
  );
}

CongesAVenir.metadata = {
  titre: "Congés à venir",
  cleMail: "conges_a_venir",
  messageTransfert: false,
  emetteur: "Gilles DELACOURT",
  emetteurPoste:
    "Responsable du Personnel et de l'Accueil – Service du Personnel",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: -30,
  piecesJointes: [],
} as MailMetadata;

export default CongesAVenir;
